module.exports = __webpack_public_path__ + "img/infograph_8.2458bccf.png";